export default __webpack_public_path__ + "static/media/pec2.b861d463.jpg";